module.exports = __webpack_public_path__ + "c26bdc13cd6963e78a03f0a5af35fd9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/national.svg
// module id = 5
// module chunks = 0